const isWidget = window.location.pathname.includes('/widget');
const isEn = window.location.hostname.toLowerCase().includes('getfloorplan');

// widget replain
if (!isWidget && isEn) {
  window.replainSettings = { id: 'c6726def-4273-41cb-bc72-6e79ac6f4e15' };
  (function (u) {
    var s = document.createElement('script');
    s.async = true;
    s.src = u;
    var x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  })('https://widget.replain.cc/dist/client.js');
}
